/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/url/GetQueryStringFromURL.ts
 * @create:      2025-06-28 09:10:26.799
 * @modify:      2025-07-11 21:19:12.801
 * @version:     6.0.0
 * @times:       5
 * @lines:       58
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { RemoveHashFromURL } from "./RemoveHashFromURL";

/**
 * Extracts the query string from a given URL, excluding any hash fragment.
 *
 * This function first removes the hash fragment from the provided URL,
 * then returns the substring following the first '?' character, if present.
 * If the URL does not contain a query string, `undefined` is returned.
 *
 * @param url - The URL string from which to extract the query string.
 * @returns The query string portion of the URL (excluding the '?'), or `undefined` if no query string exists.
 * 
 * @since 1.1.17
 * @version 2019-02-26
 */
export function GetQueryStringFromURL(url: string) {
    url = RemoveHashFromURL(url);
    const index = url.indexOf("?");

    if (index !== -1) {
        return url.substring(index + 1);
    }

    return undefined;
}
